const PlattarBase = require("../interfaces/plattar-base");

class Solution extends PlattarBase {
    static type() {
        return "solution";
    }
}

module.exports = Solution;